"use client";

import { Navigate } from "react-router-dom";
import StudentDashboardRouter from "./StudentDashboardRouter";
import TeacherDashboardRouter from "./TeacherDashboardRouter";
import StaffDashboardRouter from "./StaffDashboardRouter";
import SchoolAdminDashboardRouter from "./SchoolAdminDashboardRouter";
import SuperAdminDashboardRouter from "./SuperAdminDashboardRouter";
import SuperSchooladminDashboardRouter from "./SuperSchooladminDashboardRouter";
import VehicleTabs from "../vehicle/VehicleTabs";
import { getStoredAuth } from "../../utils/authStorage";
import { usePageTracking } from "../../hooks/usePageTracking";

function PageTracker() {
  usePageTracking();
  return null;
}

function DashboardRouter({ onLogout }) {
  const { user: storedUser, vehicle: storedVehicle } = getStoredAuth();
  const user = storedUser || storedVehicle || {};
  if (!user || !user.role) {
    return <Navigate to="/login" replace />;
  }
  const isStaffWithAdminAccess =
    user.role?.toLowerCase() === "staff" &&
    Array.isArray(user.permissions) &&
    user.permissions.length > 0;

  let roleRouter;
  switch (user.role?.toLowerCase()) {
    case "student":
      roleRouter = <StudentDashboardRouter onLogout={onLogout} />;
      break;
    case "teacher":
      roleRouter = <TeacherDashboardRouter onLogout={onLogout} />;
      break;
    case "staff":
      roleRouter = isStaffWithAdminAccess ? <SchoolAdminDashboardRouter onLogout={onLogout} /> : <StaffDashboardRouter onLogout={onLogout} />;
      break;
    case "schooladmin":
      roleRouter = <SchoolAdminDashboardRouter onLogout={onLogout} />;
      break;
    case "superadmin":
      roleRouter = <SuperAdminDashboardRouter onLogout={onLogout} />;
      break;
    case "superchooladmin":
      roleRouter = <SuperSchooladminDashboardRouter onLogout={onLogout} />;
      break;
    case "vehicle":
      return <VehicleTabs />;
    default:
      return <Navigate to="/login" replace />;
  }

  return (
    <>
      <PageTracker />
      {roleRouter}
    </>
  );
}

export default DashboardRouter;
